import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import enConfig from "../assets/locales/en.json";
import esConfig from "../assets/locales/es.json";

export default i18n.use(initReactI18next).init({
  lng: localStorage.getItem("language") || "en",
  fallbackLng: "en",
  resources: {
    en: { translation: enConfig },
    es: { translation: esConfig },
  },
});
